import { login, logout, register, getInfo, adminLogin } from '@/admin/js/api/auth';
import { isLogged, setLogged, removeToken } from '@/admin/js/utils/auth';
import router, { resetRouter } from '@/admin/js/router';
import store from '@/admin/js/store';

const state = {
  id: null,
  token: isLogged(),
  name: '',
  avatar: '',
  balance: 0,
  referral_token: '',
  roles: [],
  permissions: [],
  clicks: 0,
  impersonating: false,
  impersonator_id: null,
  impersonator_name: '',
  api_token: { plain: null, created_at: null, last_used_at: null },
  ibot_settings_enabled: false,
};

const mutations = {
  SET_IMPERSONATING: (state, v) => { state.impersonating = !!v; },
  SET_IMPERSONATOR: (state, { id = null, name = '' } = {}) => {
    state.impersonator_id = id;
    state.impersonator_name = name || '';
  },
  SET_USER_SNAPSHOT: (state, payload) => {
    state.id = payload.id;
    state.name = payload.name;
    state.avatar = payload.avatar;
    state.balance = payload.balance;
    state.clicks = payload.clicks;
    state.referral_token = payload.referral_token;
    state.roles = payload.roles || [];
    state.permissions = payload.permissions || [];
    state.impersonating = !!payload.impersonating;
    state.impersonator_id = payload.impersonator_id || null;
    state.impersonator_name = payload.impersonator_name || '';
    state.api_token = payload.api_token || { plain: null, created_at: null, last_used_at: null };
    state.ibot_settings_enabled = !!payload.ibot_settings_enabled;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_ROLES(state, roles) {
    state.roles = Array.isArray(roles) ? roles : [];
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = Array.isArray(permissions) ? permissions : [];
  },

  RESET_USER(state) {
    state.id = null;
    state.token = null;
    state.name = '';
    state.avatar = '';
    state.balance = 0;
    state.clicks = 0;
    state.referral_token = '';
    state.roles = [];
    state.permissions = [];
    state.impersonating = false;
    state.impersonator_id = null;
    state.impersonator_name = '';
    state.ibot_settings_enabled = false;
  },
};

const actions = {
  // user login
    login({ commit }, userInfo) {
        const { token, sessionDuration } = userInfo;
        return new Promise((resolve, reject) => {
            login({ token: token, sessionDuration: sessionDuration })
                .then(response => {
                    setLogged('1');
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    adminLogin({ commit }, userInfo) {

        const { email, password } = userInfo;
        return new Promise((resolve, reject) => {
            adminLogin({ email: email.trim(), password: password })
                .then(response => {
                    setLogged('1');
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    register({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            register(userInfo)
                .then(response => {
                    setLogged('1');
                    resolve();
                })
                .catch(error => {

                    reject(error);
                });
        });
    },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response;
          if (!data) return reject('Verification failed, please Login again.');

          if (!data.roles || data.roles.length <= 0) {
            return reject('getInfo: roles must be a non-null array!');
          }
          commit('SET_USER_SNAPSHOT', data);
          resolve(data);
        })
        .catch(reject);
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('RESET_USER');
          removeToken();
          resetRouter();
          resolve();
        })
        .catch(reject);
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },

  // Dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      // const token = role + '-token';

      // commit('SET_TOKEN', token);
      // setLogged(token);

      // const { roles } = await dispatch('getInfo');

      const roles = [role.name];
      const permissions = role.permissions.map(permission => permission.name);
      commit('SET_ROLES', roles);
      commit('SET_PERMISSIONS', permissions);
      resetRouter();

      // generate accessible routes map based on roles
      const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, permissions });

      // dynamically add accessible routes
      router.addRoutes(accessRoutes);

      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
